import axios from 'axios';

const httpPatch = async (
  url: string,
  data: any,
  headers?: any,
  formData?: any
) => {
  const response = await axios.patch(url, formData ?? { ...data }, {
    ...headers
  });
  return response;
};

export default httpPatch;
